module.exports = __webpack_public_path__ + "media/images/users/registrations/flow-1-0e56afb5524ea12bb053d11987b6f296.png";